<template>
   <el-card >
    <el-col :span="8" >
      <el-card style="height:calc(50vh - 40px);margin-top: 10px;margin-left:2px; overflow:auto;">
        <div slot="header" class="clearfix" >
          <span>知识题库</span>
        </div>
        <div id="qbSumChart" style="width: 100%;height:calc(50vh - 150px)"></div>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card style="height:calc(50vh - 40px);margin-top:10px;margin-left:20px; overflow:auto;">
        <div slot="header" class="clearfix" >
          <!-- <span>实验室等级</span> -->
        </div>
        <div id="safeGradeSumChart" style="width: 100%;height:calc(50vh - 150px)"></div>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card style="height:calc(50vh - 40px);margin-top:10px;margin-left:20px; overflow:auto;">
        <div slot="header" class="clearfix" >
          <!-- <span>部门实验室</span> -->
        </div>
        <div id="storeroomDeptSumChart" style="width: 100%;height:calc(50vh - 150px)"></div>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card style="height:calc(50vh - 40px);margin-top:10px;margin-left:2px; overflow:auto;">
        <div slot="header" class="clearfix" >
          <!-- <span>部门安全员</span> -->
        </div>
        <div id="storeroomUserSumChart" style="width: 100%;height:calc(50vh - 150px)"></div>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card style="height:calc(50vh - 40px);margin-top:10px;margin-left:20px; overflow:auto;">
        
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card style="height:calc(50vh - 40px);margin-top:10px;margin-left:20px; overflow:auto;">
        
      </el-card>
    </el-col>
   </el-card>
</template>                     
<script>
import axios from  '@/api/axiosConfig'
import {MESSAGE_DURATION} from  '@/api/constant'
import * as echarts from "echarts";
// import { CanvasRenderer } from "echarts/renderers";
// import { TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   DatasetComponent,
//   TransformComponent,BarChart,LabelLayout } from "echarts/components";
// echarts.use([
//   BarChart,
//   LabelLayout,
//   UniversalTransition,
//   LineChart])


export default {
  name : 'pc_ctr_home',

  data() {

    return {
      chartList :[],
      colorList : ['#51CEC6', '#FFB703', '#50A0FA', '#FAF099'
      , '#51FEC4', '#8e3e40', '#FFA0FA', '#8FF900',
      '#11AEA6', '#A0B703', '#a69843', '#99F055',
      '#66CE66', '#ff0000', '#9FA0FA', '#5AF0BB',
      '#66CE66', '#ffAAAA', '#7FA0FA', '#FAF9BB'],

      option1 : {
        tooltip: {
          trigger: 'item',
          formatter: "题库:{b}<br/>数量:{c}个<br/>占比:{d}%",
          /*formatter:function(val){   //让series 中的文字进行换行
              console.log(val);//查看val属性，可根据里边属性自定义内容
              var content = var['name'];
              return content;//返回可以含有html中标签
          },*/ //自定义鼠标悬浮交互信息提示，鼠标放在饼状图上时触发事件
        },//提示框，鼠标悬浮交互时的信息提示
        legend: {
          selectedMode: true,
          show: true,
          itemHeight: 4,
          orient: 'vertical',
          x: 'left',
          icon: 'rect',
          itemGap : 2,
          data: [],
          formatter: function (name) {
            if (name.length > 10) {
                return name.substring(0, 10) + '...';
            } else {
                return name;
            }
          },
          tooltip: {
            show: true, // 开启tooltip
            formatter: function (params) {
              return params[0].name; // 自定义格式化内容
            }
          }
        },//图例属性，以饼状图为例，用来说明饼状图每个扇区，data与下边series中data相匹配
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '题目\n' + '0个',//使用“+”可以使每行文字居中
            font: '12px',
            fill: '#000',
            // top:'center',
            // left: 'center',
            width: 20,
            height: 20
          }
        },//此例饼状图为圆环中心文字显示属性，这是一个原生图形元素组件，功能很多

        series: [{
          name: '题目数量:',//tooltip提示框中显示内容
          type: 'pie',//图形类型，如饼状图，柱状图等
          center: ['50%', '50%'],
          radius: ['50','75'],//饼图的半径，数组的第一项是内半径，第二项是外半径。支持百分比，本例设置成环形图。具体可以看文档或改变其值试一试
          //roseType:'area',是否显示成南丁格尔图，默认false
          itemStyle: {
          
          },
          labelLine: {
            show: false,
            lineStyle: {color: '#3c4858'}
          },//线条颜色

          label: {
            show: false,
            //textStyle: {color: '#3c4858', fontSize: "10"},
            // formatter: function (val) {   //让series 中的文字进行换行
            //     return val.name +"(" + val.data.value +"," + val.percent + "%)";
            // }
          },//饼图图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等。可以与itemStyle属性同级，具体看文档
          emphasis: {
            itemStyle :{
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',//鼠标放在区域边框颜色
              textColor: '#000'
            }
          },//鼠标放在各个区域的样式
          data: [],//数据，数据中其他属性，查阅文档
          color: [],//各个区域颜色
        //数组中一个{}元素，一个图，以此可以做出环形图
      },],//系列列表
      },
      optionx : {
        tooltip: {
          trigger: 'item',
          formatter: "{a}<br/>{b}: {c} ({d}%)",
          /*formatter:function(val){   //让series 中的文字进行换行
              console.log(val);//查看val属性，可根据里边属性自定义内容
              var content = var['name'];
              return content;//返回可以含有html中标签
          },*/ //自定义鼠标悬浮交互信息提示，鼠标放在饼状图上时触发事件
        },//提示框，鼠标悬浮交互时的信息提示
        legend: {
          selectedMode: true,
          show: true,
          itemHeight: 6,
          orient: 'vertical',
          x: 'left',
          icon: 'rect',
          data: []
        },//图例属性，以饼状图为例，用来说明饼状图每个扇区，data与下边series中data相匹配
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '题库\n' + '100%', //使用“+”可以使每行文字居中
            textAlign: 'center',
            font: 'italic bolder 16px cursive',
            fill: '#000',
            width: 20,
            height: 20
          }
        },//此例饼状图为圆环中心文字显示属性，这是一个原生图形元素组件，功能很多

        series: [
        {
            name: '题库',//tooltip提示框中显示内容
            type: 'pie',//图形类型，如饼状图，柱状图等
            radius: ['35%', '65%'],//饼图的半径，数组的第一项是内半径，第二项是外半径。支持百分比，本例设置成环形图。具体可以看文档或改变其值试一试
            //roseType:'area',是否显示成南丁格尔图，默认false
            itemStyle: {
              normal: {
                label: {
                  show: false,
                  //textStyle: {color: '#3c4858', fontSize: "10"},
                  // formatter: function (val) {   //让series 中的文字进行换行
                  //     return val.name +"(" + val.data.value +"," + val.percent + "%)";
                  // }
                },//饼图图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等。可以与itemStyle属性同级，具体看文档
                labelLine: {
                    show: true,
                    lineStyle: {color: '#3c4858'}
                }//线条颜色
              },//基本样式
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',//鼠标放在区域边框颜色
                textColor: '#000'
              }//鼠标放在各个区域的样式
            },
            data: [],//数据，数据中其他属性，查阅文档
            color: [],//各个区域颜色
          },//数组中一个{}元素，一个图，以此可以做出环形图
        ],//系列列表
      },
      option2: {
        xAxis: {
          name: '安全等级',
          type: 'category',
          data: []
        },
        yAxis: {
          name: '实验室数量',
          type: 'value'
        },
        series: [{
          name: '数量',
          data: [],
          barWidth: '50',
          type: 'bar',
          label: {
            show: true,
          },
          itemStyle: {
            normal: {
              label: {
                show: true,
                textStyle: {color: '#3c4858', fontSize: "15"},
                formatter: function (val) {   //让series 中的文字进行换行
                  return val.value;
                }
            },//饼图图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等。可以与itemStyle属性同级，具体看文档
              labelLine: {
                show: true,
                lineStyle: {color: '#3c4858'}
              }//线条颜色
            },//基本样式
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',//鼠标放在区域边框颜色
              textColor: '#0ff'
            }//鼠标放在各个区域的样式
          },
        }]
      },
      option3 : {
        tooltip: {
          // trigger: 'item',
          // formatter: "{a}<br/>{b}: {c} ({d}%)",
          /*formatter:function(val){   //让series 中的文字进行换行
              console.log(val);//查看val属性，可根据里边属性自定义内容
              var content = var['name'];
              return content;//返回可以含有html中标签
          },*/ //自定义鼠标悬浮交互信息提示，鼠标放在饼状图上时触发事件
        },//提示框，鼠标悬浮交互时的信息提示
        legend: {
          selectedMode: true,
          show: true,
          orient: 'vertical',
          x: 'left',
          icon: 'rect',
          data: []
        },//图例属性，以饼状图为例，用来说明饼状图每个扇区，data与下边series中data相匹配
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '实验室\n' + '100%', //使用“+”可以使每行文字居中
            textAlign: 'center',
            font: 'italic bolder 16px cursive',
            fill: '#000',
            width: 20,
            height: 20
          }
        },//此例饼状图为圆环中心文字显示属性，这是一个原生图形元素组件，功能很多

        series: [
        {
            name: '实验室',//tooltip提示框中显示内容
            type: 'pie',//图形类型，如饼状图，柱状图等
            radius: ['35%', '65%'],//饼图的半径，数组的第一项是内半径，第二项是外半径。支持百分比，本例设置成环形图。具体可以看文档或改变其值试一试
            //roseType:'area',是否显示成南丁格尔图，默认false
            itemStyle: {
              normal: {
                label: {
                  show: false,
                  textStyle: {color: '#3c4858', fontSize: "10"},
                  formatter: function (val) {   //让series 中的文字进行换行
                      return val.name +"(" + val.data.value +"," + val.percent + "%)";
                  }
                },//饼图图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等。可以与itemStyle属性同级，具体看文档
                labelLine: {
                    show: true,
                    lineStyle: {color: '#3c4858'}
                }//线条颜色
              },//基本样式
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',//鼠标放在区域边框颜色
                textColor: '#000'
              }//鼠标放在各个区域的样式
            },
            data: [],//数据，数据中其他属性，查阅文档
            color: [],//各个区域颜色
          },//数组中一个{}元素，一个图，以此可以做出环形图
        ],//系列列表
      },
      option4 : {
        tooltip: {
          // trigger: 'item',
          // formatter: "{a}<br/>{b}: {c} ({d}%)",
          /*formatter:function(val){   //让series 中的文字进行换行
              console.log(val);//查看val属性，可根据里边属性自定义内容
              var content = var['name'];
              return content;//返回可以含有html中标签
          },*/ //自定义鼠标悬浮交互信息提示，鼠标放在饼状图上时触发事件
        },//提示框，鼠标悬浮交互时的信息提示
        legend: {
          selectedMode: true,
          show: true,
          orient: 'vertical',
          x: 'left',
          icon: 'rect',
          data: []
        },//图例属性，以饼状图为例，用来说明饼状图每个扇区，data与下边series中data相匹配
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '安全员\n' + '100%', //使用“+”可以使每行文字居中
            textAlign: 'center',
            font: 'italic bolder 16px cursive',
            fill: '#000',
            width: 20,
            height: 20
          }
        },//此例饼状图为圆环中心文字显示属性，这是一个原生图形元素组件，功能很多

        series: [
        {
            name: '安全员',//tooltip提示框中显示内容
            type: 'pie',//图形类型，如饼状图，柱状图等
            radius: ['35%', '65%'],//饼图的半径，数组的第一项是内半径，第二项是外半径。支持百分比，本例设置成环形图。具体可以看文档或改变其值试一试
            //roseType:'area',是否显示成南丁格尔图，默认false
            itemStyle: {
              normal: {
                label: {
                  show: false,
                  textStyle: {color: '#3c4858', fontSize: "10"},
                  formatter: function (val) {   //让series 中的文字进行换行
                      return val.name +"(" + val.data.value +"," + val.percent + "%)";
                  }
                },//饼图图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等。可以与itemStyle属性同级，具体看文档
                labelLine: {
                    show: true,
                    lineStyle: {color: '#3c4858'}
                }//线条颜色
              },//基本样式
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',//鼠标放在区域边框颜色
                textColor: '#000'
              }//鼠标放在各个区域的样式
            },
            data: [],//数据，数据中其他属性，查阅文档
            color: [],//各个区域颜色
          },//数组中一个{}元素，一个图，以此可以做出环形图
        ],//系列列表
      },
    }
  },
  methods : {
    qbGroup(){
      let url = "/bc/exa/sum/getExamCountByModuleGroup"
      let dat0 = {

      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.length !== 0){
            let colorIndex = 0;
            let countQb = 0;
            dat.forEach(t=>{
              this.option1.series[0].data.push({value: t.count, name: t.moduleName});
              this.option1.legend.data.push(t.moduleName);
              if (colorIndex == 20) {
                  colorIndex == 0;
              }
              countQb += t.count
              this.option1.series[0].color.push(this.colorList[colorIndex]);
              colorIndex++
            })
            let  myChart = echarts.init(document.getElementById('qbSumChart'));
            
            this.option1.graphic.style.text = '题目\n' + countQb+ '个';
            myChart.setOption(this.option1);
            this.chartList.push( myChart)
          } else {
            this.$message({
              showClose: true,
              message: '未查询到题库报表信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    safeGradeGroup(){
      let url = "/bc/exa/sum/getRoomCountBySafeGroup"
      let dat0 = {

      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.length !== 0){
            dat.forEach(t=>{ 
              this. option2.series[0].data.push(t.count);
              this.option2.xAxis.data.push(t.safeGrade);    
            })
            let myChart = echarts.init(document.getElementById('safeGradeSumChart'));
           myChart.setOption(this.option2);
           this.chartList.push( myChart)
          } else {
            this.$message({
              showClose: true,
              message: '未查询到题库报表信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    storeroomGradeGroup(){
      let url = "/bc/exa/sum/getRoomAndManagerCountByDeptGroup"
      let dat0 = {

      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          let storeroomCountList = dat.storeroomCountList
          let userCountList = dat.userCountList
          if(storeroomCountList != null && storeroomCountList.length !== 0){
           let colorIndex = 5;
           storeroomCountList.forEach(t=>{
              this.option3.series[0].data.push({value: t.count, name: t.deptName});
              this.option3.legend.data.push(t.deptName);
              
              if (colorIndex == 20) {
                  colorIndex == 0;
              }
              this.option3.series[0].color.push(this.colorList[colorIndex]);
              colorIndex++
            })
            let myChart3 = echarts.init(document.getElementById('storeroomDeptSumChart'))
            myChart3.setOption(this.option3);
            this.chartList.push( myChart3)
          } else {
            this.$message({
              showClose: true,
              message: '未查询到部门实验室报表信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }


          if(userCountList != null && userCountList.length !== 0){
            let colorIndex = 10;
            userCountList.forEach(t=>{
              this.option4.series[0].data.push({value: t.count, name: t.deptName});
              this.option4.legend.data.push(t.deptName);
              if (colorIndex == 20) {
                  colorIndex == 0;
              }
              this.option4.series[0].color.push(this.colorList[colorIndex]);
              colorIndex++
            })
  
            let myChart4 = echarts.init(document.getElementById('storeroomUserSumChart'))
            myChart4.setOption(this.option4)
            this.chartList.push(myChart4)
          } else {
            this.$message({
              showClose: true,
              message: '未查询到部门安全员报表信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    resize(){
      if(this.chartList.length != 0){
        this.chartList.forEach(t=> {
          t.resize()
        })
      }
    }
  },
  mounted(){
    window.addEventListener('resize',this.resize)
  },
  created () {
    setTimeout(()=>{this.qbGroup()},200)
    //setTimeout(()=>{this.safeGradeGroup()},200)
    //setTimeout (()=>{this.storeroomGradeGroup()},200)
  },
  components: {
  },
  beforeDestroy(){
   window.removeEventListener('resize',this.resize)
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

</style>



// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_home.vue